console.log('✅ scroll-to-top.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

export async function buildComponentScrollToTop() {
  console.log(
    `🔄 Building Component: buildComponentScrollToTop  - lang: ${appState.SiteLanguageCookie} - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    //// ✅ Fetch all translations in parallel
    //const [
    //    textkeyScrollToTop,

    //    linkPaymentProtection,
    //] = await Promise.all([
    //    getTextTranslationByKey("keyScrollToTop", lang),

    //    getLinksTranslationByKey("keyPaymentProtection", lang),

    //]);

    //<img
    //    src="${imgSrcForIcons}"
    //    class="MasterPageBackToTopScrollBtn-img"
    //    width="50"
    //    height="50"

    ///>

    const imgSrcForIcons = `${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-up.svg`;

    const html = `
           <button class="MasterPageBackToTopScrollBtn" id="BtnScrollToTop">
       
             <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="MasterPageBackToTopScrollBtn-img">
      <path d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z" fill="#0F0F0F"/>
    </svg>

        </button>


        `;

    console.log('✅ ScrollToTop built successfully.');

    // Register event listeners
    registerEventListenerToAttach(initbuildComponentScrollToTop);

    return html;
  } catch (err) {
    console.error('❌ Error building ScrollToTop:', err);
    return '<div>ScrollToTop could not be loaded.</div>';
  }
}




export async function initbuildComponentScrollToTop() {
  try {
    const button = document.getElementById('BtnScrollToTop');
    if (!button) return;

    button.addEventListener('click', scrollBackToTopFunctionSmooth);

    // Initialize scroll detection or whatever SetupJavaScriptFunctionsWindowsScroll used to do
    SetupJavaScriptFunctionsWindowsScroll();

    console.log('✅ Back to Top button listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching Back to Top button listeners:', error);
  }
}

function scrollBackToTopFunctionSmooth() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function SetupJavaScriptFunctionsWindowsScroll() {
  // Example logic: show/hide button based on scroll
  const button = document.getElementById('BtnScrollToTop');
  if (!button) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 1500) {
      button.style.display = 'block';
    } else {
      button.style.display = 'none';
    }
  });
}
